export default "__VITE_ASSET__Da_X6ieP__"